import { createI18n } from "vue-i18n/index";
import translations from '@/translations/ui.json'
import luxliebeFaq from '@/translations/luxliebe-faq.json'

const messages = Object.assign({}, translations)

Object.keys(luxliebeFaq).forEach((locale) => {
    messages[locale] = Object.assign({}, messages[locale], {
        faq_luxliebe: luxliebeFaq[locale]
    })
})


const i18n = createI18n({
    locale: 'en',
    messages,
    warnHtmlInMessage: 'off'
})

export default i18n
